module.exports = __webpack_public_path__ + "img/image8.aa171d6b.png";